import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CustomThemeProvider } from './theme';
import './App.css';
import axios from 'axios';
import { supabase, getAccessToken } from './supabaseClient';

// Pages
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import Account from './pages/Account';
import About from './pages/About';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Admin from './pages/Admin';

axios.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    if (config.headers) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }
  }
  return config;
});

if (supabase) {
  supabase.auth.onAuthStateChange((_event, session) => {
    if (!session?.access_token) {
      delete axios.defaults.headers.common.Authorization;
    }
  });
}

function App() {
  return (
    <CustomThemeProvider>
      <Routes>
        <Route path="/login" element={<Navigate to="/dashboard" replace />} />
        <Route path="/signup" element={<Navigate to="/dashboard" replace />} />
        <Route path="/account" element={<Account />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </CustomThemeProvider>
  );
}

export default App;
